<template>
  <div>
    <head-content :details="details" @refresh='getDetail' :reasonList='reasonList' :productIds='productIds' />
    <box-content :rowId="rowId" />
    <base-content :details="details" />
  </div>
</template>

<script>
import HeadContent from './modal/RecordHead.vue'
import BaseContent from './modal/RecordBase.vue'
import BoxContent from './modal/RecordBox.vue'
import { getRequest } from "@/components/Common/Utils/Utils.js";
export default {
  components: {HeadContent,BaseContent,BoxContent},
  data(){
    return {
      details: {},
      rowId: getRequest('id'),
      reasonList: [],
      productIds: [getRequest('id')]
      // factoryId: getRequest('factoryId'),
    }
  },
  mounted(){
    this.getDetail()
    this.getReasonList()
  },
  methods:{
    getReasonList(){
      this.$http.get('/iot-system/dict/list?code=ebs_reason').then(res => {
        let {success,data} = res || {}
        if(success){
          let list = []
          let reasonObj = {}
          if(data && data[0]){
            let obj = data[0] || {}
            if(obj.children) {
              list = obj.children || []
              list.forEach(el => {
                reasonObj[el.dictKey] = el.dictValue || ''
              })
              this.reasonObj = reasonObj || {}
            }
          }
          this.reasonList = list || []
        }else {
          this.reasonObj = {}
          this.reasonList = []
        }
      })
    },
    getDetail() {
      this.$http.get('/nhf-custom/custompro/getCustomProductDetailById',{params: {productId: this.rowId}}).then(res => {
        if(res && res.data){
          this.details = res.data
        }
      })
    },
  }
}
</script>